import { render } from "./ShowSugestion.vue?vue&type=template&id=2d3dfba2"
import script from "./ShowSugestion.vue?vue&type=script&lang=js"
export * from "./ShowSugestion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\orcamento-online-concreto\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__